'use client';

import React, { FC, useCallback, useContext } from 'react';
import { useRouter } from 'next/navigation';

import RouteListenerContext from 'app/_context/RouteListener';
import { Button } from 'components/ui/button';
import { ArrowLeftIcon } from 'components/icons/v2';
import { MEMBER_ROUTES } from 'utils/routes';

type IBackButton = {
  onclick?: () => void;
}

export const BackButton: FC<IBackButton> = (props) => {
  const router = useRouter();

  const { routesList } = useContext(RouteListenerContext);

  const handleClickBackButton = useCallback(() => {
    const updatedArray = routesList.filter((item, index, array) => array.length - 1 !== index);

    if (!updatedArray.length) {
      return router.push(MEMBER_ROUTES.MEMBERS.getPath());
    }
    void router.back();
    if (props.onclick) props.onclick()
  }, [props.onclick, router, routesList]);

  return (
    <Button variant='tertiaryGray' size='small' onClick={handleClickBackButton}>
      <ArrowLeftIcon height={20} width={20} />
      Back
    </Button>
  );
};
